export class Slide {
	constructor(public readonly element: HTMLElement) {}

	/** Set active */
	public activate() {
		this.element.classList.remove('outgoing');
		this.element.classList.toggle('active', true);
	}

	/** Remove active and apply outgoing */
	public deactivate() {
		this.element.classList.remove('active');
		this.element.classList.toggle('outgoing', true);
	}

	/** Remove outgoing */
	public clear() {
		this.element.classList.remove('outgoing');
	}

	public get isActive() {
		return this.element.classList.contains('active');
	}

	public get isOutgoing() {
		return this.element.classList.contains('outgoing');
	}
}
